import { COUNTRIES } from "./countries";
import { USA_STATES } from "./usaStates";
/**
   * Create country and state lists and show/hide the input
   * when state list is not available.
   */
 export function processCountryState(defaultCountry = "US") {
    const country = document.getElementById("Give-Country");
    while (country.lastChild) {
      country.removeChild(country.lastChild);
    }
    const countries = COUNTRIES.map((country) => {
      const node = document.createElement("option");
      node.value = country.value;
      node.label = country.label;
      node.textContent = country.label
      return node;
    });
    country.append(...countries);
    const zipInput = document.getElementById("Give-Zip");
    zipInput?.removeAttribute("pattern");

    const state = document.getElementById("Give-State");
    while (state.lastChild) {
      state.removeChild(state.lastChild);
    }
    const states = USA_STATES.map((state) => {
      const node = document.createElement("option");
      node.value = state.value;
      node.label = state.label;
      node.textContent = state.label;
      return node;
    });
    state.append(...states);
    state.style.display = defaultCountry === "US" ? "block" : "none";
    let stateInput = document.getElementById("Give-Region");
    if (!stateInput) {// Create state Input for states outside USA

      stateInput = document.createElement("input");
      stateInput.type = "text";
      stateInput.name = "Give-Region";
      stateInput.setAttribute("data-name", "Give-Region");
      stateInput.id = "Give-Region";
      stateInput.setAttribute("class", zipInput?.classList || "default-input w-input");
      state.parentElement.appendChild(stateInput);
    }
    stateInput.style.display = defaultCountry === "US" ? "none" : "block";
    // Show/hide state input
    country.addEventListener("change", (event) => {
      if (event.target.value === "US") {
        state.style.display = "block";
        stateInput.style.display = "none";
      } else {
        state.style.display = "none";
        stateInput.style.display = "block";
      }
    });
    country.value = defaultCountry;
  };